import { useEffect, useRef, useState } from 'react';

import Tooltip from '@zenbusiness/zui/Tooltip';

import * as Styled from './OverflowText.style';

function OverflowText({ children }) {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef();

  useEffect(() => {
    const textElement = textElementRef.current;

    if (textElement) {
      setIsOverflow(textElement.scrollWidth > textElement.clientWidth);
    }
  }, []);

  return (
    <Tooltip
      componentsProps={Styled.TOOLTIP_SLOT_PROPS}
      disableHoverListener={!isOverflowed}
      disableTouchListener={!isOverflowed}
      enterTouchDelay={0}
      leaveTouchDelay={15000}
      title={children}
    >
      <Styled.TruncatedText ref={textElementRef} aria-describedby={isOverflowed ? 'tooltip' : undefined} size="md">
        {children}
      </Styled.TruncatedText>
    </Tooltip>
  );
}

export default OverflowText;
